import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

import { getEntryInfo, setStorage } from '@/utils'
import { computed, onActivated, ref, Ref, watch, onMounted } from 'vue'
import { NavBar } from 'vant'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { setDocumentTitle } from '@/utils/dom'
import AppHost, { isApp } from '@/utils/app'
import { usePlatformInfo } from '@/compositions/common'
export interface ThemeVars {
  navBarIconColor: string
  navBarArrowSize: string
  navBarTitleTextColor: string
  fontWeightBold: number
  navBarTitleFontSize: string
  lineHeightLg: string
  navBarBackgroundColor: string
  FontSizeMd: string
}

const __default__ = {
  name: 'AppHeader',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    default: '',
  },
  leftTxt: {
    type: String,
    default: '',
  },
  rightTxt: {
    type: String,
    default: '',
  },
  leftArrowShow: {
    type: Boolean,
    default: true,
  },
  rightCanClick: {
    type: Boolean,
    default: true,
  },
  rightUseSlot: {
    type: Boolean,
    default: false,
  },
  leftUseSlot: {
    type: Boolean,
    default: false,
  },
  isReturnLeftEvent: {
    type: Boolean,
    default: false,
  },
  useDefaultHeader: {
    // 使用原生的导航，则不显示header
    type: Boolean,
    default: false,
  },
},
  emits: ['leftClick', 'rightClick'],
  setup(__props, { emit: emits }) {

const props = __props;

const VanNavBar = NavBar
const { isLandscape } = usePlatformInfo()



const store = useStore()
const entryInfo = getEntryInfo()
console.log('entryInfo', entryInfo)
const useAppNav = entryInfo?.from === 'banner'

const isShow = computed(
  () => !store.getters.isMiniProgram && !window.isInIframe && !props.useDefaultHeader && !useAppNav
)

watch(
  () => props.title,
  () => {
    if (store.getters.isMiniProgram || props.useDefaultHeader || useAppNav) {
      setDocumentTitle(props.title)
    }
  },
  {
    immediate: true,
  }
)

const themeVars: Ref<ThemeVars> = ref({
  navBarHeight: '100%',
  navBarIconColor: 'rgba(0,0,0,0.88)',
  navBarArrowSize: '18px',
  navBarTitleTextColor: 'rgba(0,0,0,0.88)',
  fontWeightBold: 500,
  navBarTitleFontSize: '17px',
  lineHeightLg: '24px',
  navBarBackgroundColor: 'transparent',
  FontSizeMd: '16px',
})

const appStatusBarHeight = computed<number>(() =>
  isLandscape.value ? 0 : store.state.appStatusBarHeight
)

// const navHeight = 44

const router = useRouter()
function onClickLeft() {
  if (props.isReturnLeftEvent) {
    emits('leftClick')
  } else {
    if (isApp && history.length === 1) {
      AppHost.goAppBack()
      return
    }
    router.go(-1)
  }
}

function onClickRight(): void {
  if (!props.rightCanClick) return
  emits('rightClick')
}
function updateTitle() {
  store.getters.isMiniProgram && setDocumentTitle(props.title)
}
onActivated(() => {
  updateTitle()
})
onMounted(() => {
  updateTitle()
})

return (_ctx: any,_cache: any) => {
  const _component_van_config_provider = _resolveComponent("van-config-provider")!

  return _withDirectives((_openBlock(), _createBlock(_component_van_config_provider, { "theme-vars": themeVars.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle({ height: _unref(appStatusBarHeight) + 'px' })
      }, null, 4),
      _createVNode(_unref(VanNavBar), {
        title: __props.title,
        "left-text": __props.leftTxt,
        "left-arrow": __props.leftArrowShow,
        onClickLeft: onClickLeft,
        onClickRight: onClickRight,
        class: "nav-bar"
      }, _createSlots({
        right: _withCtx(() => [
          (__props.rightUseSlot)
            ? _renderSlot(_ctx.$slots, "right", { key: 0 })
            : (__props.rightTxt)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(__props.rightCanClick ? 'can-click' : 'no-can-click'),
                  style: {"font-weight":"500"}
                }, _toDisplayString(__props.rightTxt), 3))
              : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (__props.leftUseSlot)
          ? {
              name: "left",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "left")
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title", "left-text", "left-arrow"])
    ]),
    _: 3
  }, 8, ["theme-vars"])), [
    [_vShow, _unref(isShow)]
  ])
}
}

})